import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--pill"
// Handles pill removal with animation
export default class extends Controller {
  remove(event) {
    // Link-variant pills (removable mobile filter chips) remove the filter by
    // NAVIGATING to an href that drops the slice — let the browser proceed.
    // preventDefault + DOM-removal here used to cancel the navigation AND
    // vanish the chip, leaving the filter applied with no way to clear it.
    if (this.element.tagName === "A" && this.element.getAttribute("href")) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    // Dispatch remove event before animation
    this.element.dispatchEvent(
      new CustomEvent("pill:remove", {
        bubbles: true,
        detail: { pill: this.element },
      }),
    )

    // Animate out
    this.element.style.transition = "opacity 200ms, transform 200ms"
    this.element.style.opacity = "0"
    this.element.style.transform = "scale(0.8)"

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
